import { Box, Drawer } from '@mui/material';
import styled from '@emotion/styled';
import {
  leftDrawerDimen,
  mainAppBarDimen,
  mainDrawerDimen,
  toolBarDimen,
  toPixel,
} from '../styles/dimensions';
import { useMainFrameState } from '../MainFrame';

const mainDrawerMixin = mainDrawerOpen => {
  return {
    ...(mainDrawerOpen && {
      marginLeft: toPixel(mainDrawerDimen.open.width),
      // marginLeft: '140px',
    }),
    ...(!mainDrawerOpen && {
      marginLeft: toPixel(mainDrawerDimen.closed.width),
    }),
  };
};

const toolBarMixin = isToolbarOpen => {
  return {
    ...(isToolbarOpen && {
      marginTop: toPixel(toolBarDimen.height + mainAppBarDimen.height),
      height: `calc(100vh - ${toPixel(
        toolBarDimen.height + mainAppBarDimen.height
      )})`,
    }),
    ...(!isToolbarOpen && {
      marginTop: toPixel(mainAppBarDimen.height),
    }),
  };
};

const openMixin = (theme, mainDrawerOpen, isToolbarOpen) => {
  return {
    width: toPixel(leftDrawerDimen.open.width),
    '& .MuiDrawer-paper': {
      width: toPixel(leftDrawerDimen.open.width),
      backgroundColor: theme.palette.leftFloatingDrawerColor,
      ...mainDrawerMixin(mainDrawerOpen),
      ...toolBarMixin(isToolbarOpen),
    },
  };
};

const closeMixin = (theme, mainDrawerOpen, isToolbarOpen) => {
  return {
    width: toPixel(leftDrawerDimen.closed.width),
    '& .MuiDrawer-paper': {
      width: toPixel(leftDrawerDimen.closed.width),
      backgroundColor: theme.palette.leftFloatingDrawerColor,
      ...mainDrawerMixin(mainDrawerOpen),
      ...toolBarMixin(isToolbarOpen),
    },
  };
};

const NVDrawerLeft = styled(Drawer, {
  shouldForwardProp: props => true,
})(props => {
  const { theme, open, mainDrawerOpen, isToolbarOpen } = props;
  console.log(props);
  return {
    // transition: theme.transitions.create(['width', 'margin'], {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
    ...(open && openMixin(theme, mainDrawerOpen, isToolbarOpen)),
    ...(!open && closeMixin(theme, mainDrawerOpen, isToolbarOpen)),
  };
});
const NVDrawerLeftComponent = () => {
  const { mainDrawerOpen, isLeftDrawerOpen, isToolbarOpen, LeftDrawerJsx } =
    useMainFrameState();
  return (
    <>
      <NVDrawerLeft
        variant="permanent"
        open={isLeftDrawerOpen}
        mainDrawerOpen={mainDrawerOpen}
        isToolbarOpen={isToolbarOpen}
      >
        <Box
          sx={{
            marginBottom: toPixel(mainAppBarDimen.height),
          }}
        >
          <div>{LeftDrawerJsx}</div>
        </Box>
      </NVDrawerLeft>
    </>
  );
};

export default NVDrawerLeftComponent;
